import { render, staticRenderFns } from "./autocomplete-phone-number.vue?vue&type=template&id=0878daee&scoped=true&"
import script from "./autocomplete-phone-number.vue?vue&type=script&lang=js&"
export * from "./autocomplete-phone-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0878daee",
  null
  
)

export default component.exports